"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonTipTargetProps = void 0;

var spaui_1 = require("@tencent/spaui");

var react_1 = __importDefault(require("react"));

var getButtonTipTargetProps = function getButtonTipTargetProps(data, useTipTarget) {
  if (data === void 0) {
    data = {};
  }

  if ((data === null || data === void 0 ? void 0 : data.tip) && ((data === null || data === void 0 ? void 0 : data.useTipTarget) || useTipTarget)) {
    return {
      OverlayTriggerProps: {
        placement: 'auto',
        defaultPlacement: 'top',
        autoPlacementBasic: 'window',
        hideDelayTime: 0
      },
      tipTarget: react_1["default"].createElement("i", {
        className: "spaui-icon svg-icon svg-icon-help"
      }, react_1["default"].createElement(spaui_1.Icon, {
        name: "question-filled"
      }))
    };
  }

  return {};
};

exports.getButtonTipTargetProps = getButtonTipTargetProps;